module.exports = __webpack_public_path__ + "static/img/tuangou.e324a044.png";